<script>
    import FormModal from '../../../../../../../../Pages/components/modals/FormModal';
    import { piniaPlugin } from '../../../../../../../stores';
    import axios from "axios";
    import { Inertia } from '@inertiajs/inertia';
    
    export default {
        components: {
            FormModal
        },
        props: {
            dataType: {
                type: String,
                default: null,
            },
            folderId: {
                type: [Number, String]
            },
            routeType: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                isShowModal: false,
                allFolders: [],
                allFiles: [],
                folderLoader: false,
                fileLoader: false,
                selectedFolderId: null,
                folderType: this.dataType === 'OwnContent' || this.dataType === 'Own' ? 'own' : 'shared',
                fetchingRequestData: {
                    document_id: null,
                    platform: 'vue'
                }
            }
        },
        setup() {
            const store = piniaPlugin();
            return { store };
        },
        computed: {
            userTypeAbbr() {
				return this.$page.props.auth.user.user_type_abbr;
			},
        },
        methods: {
            dowloadFiles() {
                this.folderLoader = true
                this.isShowModal = true
                this.selectedFolderId = null
                this.allFiles = []
                axios.post(route('get-folder-list-by-type'), {type: this.folderType, id: this.folderId}, {
                    })
                    .then(response => {
						this.allFolders = response.data;
						this.folderLoader = false;
                    })
                    .catch(err => {
                        this.allFolders = [];
                        this.folderLoader = false;
                    });
            },
            hideModal(){
                this.isShowModal = false
            },
            getAllFiles(docId) {
                this.fileLoader = true;
                this.fetchingRequestData.document_id = docId
                if(this.dataType === 'SharedContent' || this.dataType === 'Shared') {
                    let extraFetchingRequestData = {isShared: true}
                    this.fetchingRequestData = {
                        ...this.fetchingRequestData,
                        ...extraFetchingRequestData
                    }
                }
                axios.post(
                    route(this.userTypeAbbr + '_get_folder_contents_from_single_view'),
                    this.fetchingRequestData, {
                        
                    })
                    .then(response => {
						this.allFiles = response.data;
						this.fileLoader = false;
                    })
                    .catch(err => {
                        this.allFiles = [];
                        this.fileLoader = false;
                        if(err) {
                            this.$toastr.e(err.response.data.message);
                        }
                });
            },
            getUserType(item) {
                if (item.document_managed_by.user_type == 1) {
                    return 'Admin';
                }
                else if (item.document_managed_by.user_type == 2) {
                    return 'EP';
                }
                else if (item.document_managed_by.user_type == 3) {
                    return 'TC';
                }
                else if(item.document_managed_by.user_type == 4) {
                    return 'TP';
                }
                else {
                    return '';
                }
            },
            inertiaVisitUrl(url) {
                Inertia.visit(route(url));
            }
        }
    };
</script>

<template>
    <div>
        <FormModal
            :isShow="isShowModal"
            title="Download files after choose any folder"
            :isShowSubmitButton="false"
            :isShowCancelButton="true"
            @hideModal="hideModal"
        >
            <div class="row">
                <div class="col-12">
                    <div class="mb-3 mt-3 mt-lg-0">
                        <div v-if="folderLoader" class="text-center">
                            <div class="spinner-border text-success m-3" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else class="mb-3">
                            <label for="folder">Choose folder to download files</label>
                            <b-form-select v-model="selectedFolderId" class="form-control" @change="getAllFiles(selectedFolderId)">
                                <b-form-select-option :value="null">Please select folder</b-form-select-option>
                                <b-form-select-option v-for="(item, index) in this.allFolders.data" :value="item.id" :key="index">
                                    {{ item.document_name }}{{ item.document_managed_by ? ` (${item.document_managed_by.name},${getUserType(item)})` : '' }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                        <div v-if="fileLoader" class="spinner-border text-success m-3" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div v-else class="row mb-3">
                            <div v-for="(item, index) in this.allFiles.data" :key="index" class='col-sm-6'>
                                <a :href='item.downloadUrl' :download="item.name">{{item.name}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FormModal>
        <b-dropdown
            class="mb-0"
            toggle-class="btn btn-link text-muted"
            menu-class="dropdown-menu-end"
            right
            variant="white"
        >
            <template #button-content>
                <i class="mdi mdi-dots-vertical font-size-20"></i>
            </template>
            <b-dropdown-item v-if="store.useMultiSelect.isShowActionButton" href="Javascript:void(0)" @click="store.useMultiSelect.multiSelectFileFolder('selectAll')"><span class="h6"><i class="mdi mdi-checkbox-marked text-primary"></i> Select All</span></b-dropdown-item>
            <b-dropdown-item v-if="store.useMultiSelect.isShowActionButton" href="Javascript:void(0)" @click="store.useMultiSelect.multiSelectFileFolder('deSelectAll')"><span class="h6"><i class="mdi mdi-checkbox-blank-outline text-primary"></i> Deselect All</span></b-dropdown-item>
            <b-dropdown-item v-if="routeType === 'Trash'" href="Javascript:void(0)" @click="store.useTrashStore.emptyTrash(userTypeAbbr)"><span class="h6"><i class="mdi mdi-trash-can-outline text-primary"></i> Empty Trash</span></b-dropdown-item>
            <template v-else>
                <b-dropdown-item href="Javascript:void(0)" @click="dowloadFiles()"><span class="h6"><i class="mdi mdi-download-multiple text-primary"></i> Download</span></b-dropdown-item>
                <b-dropdown-item v-if="routeType !== 'Shared'" href="Javascript:void(0)" @click="inertiaVisitUrl(userTypeAbbr + '-document-manager-trash')"><span class="h6"><i class="mdi mdi-trash-can-outline text-primary"></i> Trash</span></b-dropdown-item>
            </template>
        </b-dropdown>
    </div>
</template>
